import { ProductAttributes } from "@secureo/common/typings/Product"

const getInitialCylinderConfigurationVariantSku = (
	masterVariantSku: string,
	masterVariantAttributes: ProductAttributes,
) => {
	const {
		lengthCombinationsBySystem,
		innerLengthsByOuterLengths,
		outerLengths,
		outerLengthsBySystem,
		systems,
	} = masterVariantAttributes

	if (lengthCombinationsBySystem) {
		const [initialSystem] = Object.keys(lengthCombinationsBySystem)
		const [initialLengthCombination] = lengthCombinationsBySystem?.[initialSystem] ?? []

		return initialLengthCombination.sku
	}

	if (innerLengthsByOuterLengths) {
		const [initialOuterLength] = Object.keys(innerLengthsByOuterLengths)
			.map((outerLength) => Number(outerLength))
			.sort((a, b) => a - b)
		const [initialInnerLength] = innerLengthsByOuterLengths?.[initialOuterLength] ?? []

		const initialCylinderConfigurationVariantSku = `${masterVariantSku}-${initialOuterLength}-${initialInnerLength}`
		return initialCylinderConfigurationVariantSku
	}

	if (outerLengths) {
		const [initialOuterLength] = outerLengths

		const initialCylinderConfigurationVariantSku = `${masterVariantSku}-${initialOuterLength}`
		return initialCylinderConfigurationVariantSku
	}

	if (outerLengthsBySystem) {
		const [initialSystem] = Object.keys(outerLengthsBySystem).sort()
		const [initialOuterLength] = outerLengthsBySystem?.[initialSystem] ?? []

		return initialOuterLength.sku
	}

	if (systems) {
		const [initialSystem] = systems

		return initialSystem.sku
	}

	return null
}

export default getInitialCylinderConfigurationVariantSku
